import GlobalSearchV2 from '../../../../../../components/GlobalSearchV2';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
function SearchPage(props) {
  const {authToken, title, description} = props;
  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col xs="12" md="8">
            <h4>{title ? title : 'Search Whole Life Club'}</h4>

            <p>{description ? description : 'Search through our recipes, weekly guides, videos, and more.'}</p>
          </Col>
        </Row>
      </Container>
      <GlobalSearchV2
        hideFilterBy
        authToken={authToken}
        types={['week', 'videoresource', 'article', 'download', 'link']}
      />
    </React.Fragment>
  );
}
export default SearchPage;
